import { createFileRoute } from '@tanstack/react-router'
import PlusIcon from '~/components/icons/PlusIcon'
import { BrandsPanel } from '~/components/routes/categories/BrandsPanel'
import { CategoriesPageLayout } from '~/components/routes/categories/categories-page-layout'
import { useRights } from '~/utils/hooks'
import { AuthorizedButtonLink, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/categories/brands')({
  staticData: {
    permission: ['read', 'categories'],
  },
  component: BrandsTabPage,
})
withRoutePermissions(Route)

function BrandsTabPage() {
  const isAdmin = useRights(['ADMIN'])

  return (
    <CategoriesPageLayout
      activeTab="brands"
      actions={
        <AuthorizedButtonLink
          variant="contained"
          sx={{ marginRight: '16px' }}
          to="/categories/brand/new"
          disabled={!isAdmin}
        >
          <PlusIcon />
          Ajouter une marque
        </AuthorizedButtonLink>
      }
    >
      <BrandsPanel />
    </CategoriesPageLayout>
  )
}
